import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import "./EventsDataDetails.scss";

const EventsDataDetails = () => {
  const { eventId } = useParams();

  const [eventDetail, setEventDetail] = useState({});

  const { image, price, title, description } = eventDetail;

  useEffect(() => {
    axios
      .get(`https://fakestoreapi.com/products/${eventId}`)
      .then((res) => setEventDetail(res.data));
  });
  return (
    <>
      <div className="container">
        <div className="event_details_box">
          <div className="text-center">
            <img src={image} className="img-fluid" alt="" />
          </div>
          <div className="d-flex justify-content-center">
            <div className="text_details">
              <div className="title">{price}</div>
              <h3>{title}</h3>
              <p>{description}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventsDataDetails;
